import { CartRequestBody, CalculateCartResponse } from "@/types/receipt";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "..";
import api from "@/services/api";
import useModalsStore from "@/stores/modals";
import { isAxiosError } from "axios";
import { playSound, SoundOption } from "@/helpers/playSound";

export const calculateCart = createAsyncThunk<
  CalculateCartResponse,
  { body: CartRequestBody; expectAge?: boolean },
  { state: RootState }
>("cart/calculateCart", async ({ body, expectAge }) => {
  try {
    const res = await api.cart.calculate(body);
    if (expectAge && res.data.data.legalAge !== null) {
      useModalsStore.getState().setShowAgeVerification(true);
    } else if (expectAge) {
      useModalsStore.getState().setInvalidQrModal(true);
    }
    return res.data.data;
  } catch (e) {
    if (!isAxiosError(e)) throw e;
    const statusCode = e?.response?.status;
    if (statusCode === 422) {
      const data = e?.response?.data as {
        data: { lineItems: CalculateCartResponse["lineItems"] };
        error: string;
      };
      useModalsStore.getState().setVoucherNotValidReason(data.error);
      playSound(SoundOption.VoucherAddError);
    } else if (statusCode === 404) useModalsStore.getState().setVoucherNotFound(true);
    else useModalsStore.getState().setUnknownError(true);
    throw e;
  }
});
